export enum FeeWaiverTypeEnum {
    PRESET = 1,
    AUTOMATED_EDITABLE,
    AUTOMATED_NON_EDITABLE,
    MANUALLY_ADDED,
}
